import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AccountsService } from 'app/system/services/accounts.service';
import { LoginActivateResolve } from 'app/system/routes/login/login-activate.resolver';
import { IsAuthGuard } from 'app/system/guards/isauth.guard';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: '', redirectTo: 'signin', pathMatch: 'full' },
      {
        path: 'signin',
        loadChildren: './login-signin/login-signin.module#LoginSignInModule',
        pathMatch: 'full',
        canActivate: [
          IsAuthGuard
        ],
        data: {
          navigateIf: {
            isAuth: true,
            to: ['/']
          }
        }
      },
      { path: 'register', loadChildren: './login-register/login-register.module#LoginRegisterModule' },
      { path: 'recovery', loadChildren: './login-recovery/login-recovery.module#LoginRecoveryModule' },
      { path: 'password', loadChildren: './login-password/login-password.module#LoginPasswordModule' },
      {
        path: 'activate',
        loadChildren: './login-activate/login-activate.module#LoginActivateModule',
        resolve: { routeResolvedData: LoginActivateResolve }
      }
    ])
  ],
  providers: [
    IsAuthGuard,
    LoginActivateResolve
  ]
})
export class LoginModule { }